export default __webpack_public_path__ + "static/media/grey_earth.d65fba4b.png";